var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emain"},[_c('el-container',{staticClass:"show-container"},[_c('el-main',{staticStyle:{"padding":"0"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }